/**
 * The parent's «сегодня» card on the home screen (docs/PATH-V2.md §4.5): three short lines — done, next, one finding —
 * and the way into «Для взрослых» (behind the parent gate there). Small type: it is for the adults, the doors above
 * stay the child's — on a short laptop / tablet window it steps aside (CSS) so the home keeps its one screen.
 */
import type { ReactElement } from 'react';
import styles from './TodayCard.module.css';
import type { ParentToday } from './todayCard.ts';

export function TodayCard({ today, onOpen }: { today: ParentToday; onOpen(): void }): ReactElement {
  return (
    <section className={styles.card} aria-label="Для взрослых: сегодня">
      <h2 className={styles.title}>Для взрослых · сегодня</h2>
      <ul className={styles.lines}>
        <li>
          <span aria-hidden="true">✓</span> {today.done}
        </li>
        {today.next ? (
          <li>
            <span aria-hidden="true">▶</span> {today.next}
          </li>
        ) : null}
        {today.finding ? (
          <li>
            <span aria-hidden="true">💡</span> {today.finding}
          </li>
        ) : null}
      </ul>
      <button type="button" className={styles.more} onClick={onOpen}>
        Подробнее
      </button>
    </section>
  );
}
